import * as React from 'react'
import { cn } from '@/lib/utils'

interface BaseProps {
  className?: string
  children?: React.ReactNode
}

export function Prose({ className, children }: BaseProps) {
  return (
    <div className={cn('max-w-[720px] text-[15px] leading-[1.75] text-foreground', className)}>
      {children}
    </div>
  )
}

export function H1({ className, children }: BaseProps) {
  return (
    <h1 className={cn('text-3xl md:text-4xl font-semibold tracking-tight text-foreground', className)}>
      {children}
    </h1>
  )
}

export function H2({ className, children }: BaseProps) {
  return (
    <h2 className={cn('text-xl md:text-2xl font-semibold mt-10 mb-3 scroll-mt-20 text-foreground', className)}>
      {children}
    </h2>
  )
}

export function H3({ className, children }: BaseProps) {
  return (
    <h3 className={cn('text-lg font-semibold mt-6 mb-2 text-foreground', className)}>
      {children}
    </h3>
  )
}

export function P({ className, children }: BaseProps) {
  return (
    <p className={cn('text-[15px] leading-[1.75] text-foreground/85 mb-4', className)}>
      {children}
    </p>
  )
}

export function UL({ className, children }: BaseProps) {
  return (
    <ul className={cn('list-disc pl-5 space-y-1.5 text-[15px] leading-[1.75] text-foreground/85 mb-4', className)}>
      {children}
    </ul>
  )
}

export function OL({ className, children }: BaseProps) {
  return (
    <ol className={cn('list-decimal pl-5 space-y-1.5 text-[15px] leading-[1.75] text-foreground/85 mb-4', className)}>
      {children}
    </ol>
  )
}

export function Lead({ className, children }: BaseProps) {
  return (
    <p className={cn('text-base md:text-lg text-muted-foreground leading-relaxed', className)}>
      {children}
    </p>
  )
}
